(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const offers = document.querySelector('[data-sk-scanner-offers]');
  const guide = document.querySelector('[data-sk-scanner-guide]');
  if (!offers && !guide) return;

  const productHandleFromHref = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const allowedHosts = new Set([
        window.location.hostname.toLowerCase(),
        'skhonpo.com',
        'www.skhonpo.com',
      ]);
      if (!allowedHosts.has(url.hostname.toLowerCase())) return '';

      const segments = url.pathname.split('/').filter(Boolean);
      const productsIndex = segments.indexOf('products');
      if (productsIndex < 0 || !segments[productsIndex + 1] || segments.length !== productsIndex + 2) {
        return '';
      }
      return decodeURIComponent(segments[productsIndex + 1]);
    } catch {
      return '';
    }
  };

  const sendEvent = (name, parameters = {}) => {
    const payload = {
      event: name,
      page_type: 'scanner_comparison_article',
      article_handle: '3d-scanner-comparison-2026',
      ...parameters,
    };

    if (typeof window.gtag === 'function') {
      const { event, ...gtagParameters } = payload;
      window.gtag('event', event, gtagParameters);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  if (offers) {
    let offerViewSent = false;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (offerViewSent || !entries.some((entry) => entry.isIntersecting)) return;
          offerViewSent = true;
          sendEvent('scanner_comparison_offers_viewed');
          observer.disconnect();
        },
        { threshold: 0.35 },
      );
      observer.observe(offers);
    } else {
      offerViewSent = true;
      sendEvent('scanner_comparison_offers_viewed');
    }

    offers.addEventListener('click', (event) => {
      const productLink = event.target.closest('[data-sk-scanner-product-link]');
      if (productLink) {
        sendEvent('scanner_comparison_product_clicked', {
          product_handle: productLink.dataset.productHandle || '',
          use_case: productLink.dataset.useCase || '',
          placement: 'article_quick_picks',
        });
        return;
      }

      const collectionLink = event.target.closest('[data-sk-scanner-collection-link]');
      if (collectionLink) sendEvent('scanner_comparison_collection_clicked');
    });
  }

  if (guide) {
    guide.addEventListener('click', (event) => {
      const contactLink = event.target.closest('[data-sk-scanner-contact]');
      if (contactLink) {
        sendEvent('scanner_comparison_contact_clicked', { placement: 'article_support' });
        return;
      }

      const productLink = event.target.closest('a[href]');
      const productHandle = productLink
        ? productHandleFromHref(productLink.getAttribute('href'))
        : '';
      if (productHandle) {
        sendEvent('scanner_comparison_product_clicked', {
          product_handle: productHandle,
          placement: 'article_body',
        });
      }
    });
  }
})();
